import React, { useState, useEffect } from "react";
import { Checkbox, Descriptions, Tabs, Row, Col, Modal } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { LayoutData } from "../Structur/Aconlayout";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { DelphiDatumShow } from "../Helper/DateTimeHelper.jsx";
import { IntToBetrag } from "../Helper/ZahlenFormat.jsx";
import { EditOutlined, PlusSquareOutlined } from "@ant-design/icons";
import { EvidenzEvAdrDatenEdit } from "./EvidenzEvAdrDatenEdit.jsx";
import { DeleteConfirmationModal } from "../Helper/DeleteConfirmationModal";

export const EvidenzDatenDetails = ({ aktEvadrRecNr, setTitel, gruppe }) => {
  const [url1, setUrl1] = useState("");
  const { user, logoutLogin, apiBaseUrl } = LayoutData();
  const [dataSource, setDataSource] = useState();
  const [items1, setItems1] = useState();
  const [items2, setItems2] = useState();
  const [items3, setItems3] = useState();
  const [items4, setItems4] = useState();
  const [tabIndex, setTabIndex] = useState(1);
  const [modalOpen, setModalOpen] = useState();
  const [modalOpen2, setModalOpen2] = useState();
  const [modatTitel, setModalTitel] = useState();
  const queryClient = useQueryClient();

  // Es muss immer ein BaseUrl geben
  useEffect(() => {
    // console.log("XXX ", apiBaseUrl, aktRecnr);
    if (apiBaseUrl && aktEvadrRecNr !== undefined && aktEvadrRecNr !== 0) {
      setUrl1(
        `${apiBaseUrl}api/evdatensuche?recnr=${aktEvadrRecNr}&art=${gruppe}`
      );
    }
  }, [apiBaseUrl, aktEvadrRecNr]);

  const {
    isPending: isPending1,
    error: error1,
    data: evadrData,
    refetch: refetchEmailData1,
  } = useQuery({
    queryKey: [url1],
    queryFn: () => {
      if (url1) {
        // Überprüfen, ob url1 definiert ist
        return fetch(url1, {
          headers: {
            Authorization: `Bearer ${user.bearer}`,
          },
        }).then((res) => {
          if (res.status === 401) logoutLogin();
          return res.json();
        });
      } else {
        // Wenn url1 nicht definiert ist, gib ein leeres Objekt zurück oder handle den Fall entsprechend
        return null; // Promise.resolve({});
      }
    },
  });
  if (error1) {
    console.log("url1", url1);
    console.error("XXX Error", error1);
    // logout();
  }

  useEffect(() => {
    if (evadrData) {
      let itemsData = [];
      const add = (title, text) => {
        itemsData.push({
          label: <>{title}</>,
          children: <>{text}</>,
          key: itemsData.length,
        });
      };
      add("Name", evadrData.name);
      add("Gruppe", evadrData.gruppe);
      add("Ort", evadrData.ort);
      add("Aktiv", <Checkbox checked={evadrData.aktiv} />);
      add("Lieferant", <Checkbox checked={evadrData.islief} />);
      add("Kundentreue", <Checkbox checked={evadrData.kundentreue} />);
      add("Profi English", <Checkbox checked={evadrData.profienglish} />);
      add("Sprache", evadrData.sprache);
      add("Kundentreuemaxtage", evadrData.kundentreuemaxtage);

      add("Betreuer", evadrData.betreuer);
      add("Besuchsplanung", <Checkbox checked={evadrData.besuchsplanung} />);
      add("UID-Nummer", evadrData.atunummer);
      add("Konto", evadrData.konto);

      add("Skonto Tage", evadrData.skontotage);
      add("Skonto %", evadrData.skontoprozent);
      add("Skonto netto", evadrData.skontonetto);
      add("Skonto 2 Tage", evadrData.skonto2tage);
      add("Skonto 2 %", evadrData.skonto2prozent);
      add("Lizenzstatus", evadrData.lizenzstatus);
      add("Lizenzname", evadrData.lizenzname);
      add("Lizenznameerweiterung", evadrData.lizenznameerweiterung);
      add("Modulstatus", evadrData.modulstatus);
      add("Locationlat", evadrData.locationlat);
      add("Locationlng", evadrData.locationlng);
      add("Ergprefix", evadrData.ergprefix);
      add("Eguprefix", evadrData.eguprefix);
      add("Erechnungauftragref", evadrData.erechnungauftragref);
      add("Erechnungsubjectart", evadrData.erechnungsubjectart);
      add("Pdf-Offen", <Checkbox checked={evadrData.pdfoffen} />);
      setItems1(itemsData);

      itemsData = [];
      for (let i = 0; i < 50; i++) add(`Text ${i}`, evadrData.txdaten[i]);
      setItems2(itemsData);

      itemsData = [];
      for (let i = 0; i < 50; i++)
        add(`Betrag ${i}`, <>{IntToBetrag(evadrData.lidaten[i])}</>);
      setItems3(itemsData);

      itemsData = [];
      for (let i = 0; i < 50; i++)
        add(`Schalter ${i}`, <Checkbox checked={evadrData.schalter[i]} />);
      setItems4(itemsData);

      /*
      add("Imendo Kunde", <Checkbox checked={aconkundenData.imendo} />);
      add("Updatepreis", <IntToBetrag zahl={aconkundenData.updatepreis} />);
     
      add(
        "Von Datum",
        <DelphiDatumShow delphiDatum={aconkundenData.vondatum} />
      );
*/
      //checkMainContainerHeight();
      setDataSource(evadrData);
    }
  }, [evadrData]);

  // Funktion zum Verarbeiten von Änderungen, wenn der Tab gewechselt wird
  const onChange = (key) => {
    console.log("onChange", key, "last ", tabIndex);
    setTabIndex(key);
  };

  // Funktion zum Verarbeiten von Daten, wenn etwas bearbeitet wird
  const handleDatenEdit = (e) => {
    //console.log("handleDatenEdit", e, tabEditIndex);
    doEditDaten();
    // Füge hier deine Logik hinzu, um die Daten basierend auf tabEditIndex zu bearbeiten
  };

  useEffect(() => {
    //console.log("tabEditIndex geändert", tabEditIndex);
    if (evadrData)
      setTitel(
        <>
          <Row justify="space-between" align="middle">
            <Col>{evadrData.name}</Col>
            <Col>
              <span
                onClick={handleDatenEdit}
                style={{ cursor: "pointer", fontSize: 23, marginTop: 3 }}
              >
                <EditOutlined />
              </span>
            </Col>
          </Row>
        </>
      );
  }, [tabIndex, evadrData, setTitel]);

  const tabItems = [
    {
      key: "1",
      label: "Main",
      children: (
        <Descriptions
          //title="User Info"
          items={items1}
          column={1}
          size="small"
          bordered={true}
          loading={isPending1.toString()}
        />
      ),
    },
    {
      key: "2",
      label: "Texte",
      children: (
        <Descriptions
          //title="User Info"
          items={items2}
          column={1}
          size="small"
          bordered={true}
          loading={isPending1.toString()}
        />
      ),
    },
    {
      key: "3",
      label: "Zahlen",
      children: (
        <Descriptions
          //title="User Info"
          items={items3}
          column={1}
          size="small"
          bordered={true}
          loading={isPending1.toString()}
        />
      ),
    },
    {
      key: "4",
      label: "Schalter",
      children: (
        <Descriptions
          //title="User Info"
          items={items4}
          column={1}
          size="small"
          bordered={true}
          loading={isPending1.toString()}
        />
      ),
    },
  ];

  const doEditDaten = () => {
    // console.log("doEditDaten", tabIndex);
    switch (parseInt(tabIndex)) {
      case 2:
        setModalTitel(
          <>
            Texte:<b> {evadrData.name}</b>
          </>
        );
        break;
      case 3:
        setModalTitel(
          <>
            Zahlen:<b> {evadrData.name}</b>
          </>
        );
        break;
      case 4:
        setModalTitel(
          <>
            Schalter:<b> {evadrData.name}</b>
          </>
        );
        break;
      default:
        setModalTitel(
          <>
            Main:<b> {evadrData.name}</b>
          </>
        );
        break;
    }

    setModalOpen(true);
    //EvidenzEvAdrDatenEdit = ({tabIndex, handleFinish, editDaten ,handleDelete}) => {
  };
  const convert01 = (saveDaten, propName) => {
    if (saveDaten && saveDaten.hasOwnProperty(propName)) {
      saveDaten[propName] = saveDaten[propName] ? 1 : 0;
    }
  };
  const handleFinish = async (values) => {
    console.log("handleFinish", values);
    // hier sollen die Änderungen gespeichert werden
    let saveDaten = {};
    if (evadrData === null) {
      saveDaten = values;
      saveDaten["recnr"] = 0;
    } else {
      //console.log("********************");
      for (const key in values) {
        if (
          values.hasOwnProperty(key) &&
          (evadrData === null || evadrData.hasOwnProperty(key))
        ) {
          if (evadrData === null || values[key] !== evadrData[key]) {
            // Der Wert des Schlüssels hat sich geändert
            //console.log(key, aktvalues[key], daten[key]);
            saveDaten[key] = values[key];
          }
        }
      }
      saveDaten["recnr"] = evadrData.recnr;
    }

    saveDaten["art"] = gruppe;
    convert01(saveDaten, "aktiv"); // Wenn in der DB 01 erwartet wird
    convert01(saveDaten, "islief");
    convert01(saveDaten, "besuchsplanung");
    convert01(saveDaten, "profienglish");
    convert01(saveDaten, "pdfoffen");
    console.log("saveDaten", saveDaten);
    const respone = await postEvAdrDaten(saveDaten, apiBaseUrl, user.bearer);
    console.log("respone", respone);
    // Annahme: Du hast eine Query mit dem Key 'meineDaten'
    queryClient.removeQueries(url1);
    refetchEmailData1();
    setModalOpen(false);
  };
  const handleDelete = () => {
    // Zu viel zu löschen am Server !!!

    setModalOpen(false);
    setModalOpen2(false);
  };

  const postEvAdrDaten = async (data, baseUrl, bearer) => {
    const response = await fetch(`${baseUrl}api/evadr/saveJson`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${bearer}`,
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  };

  return (
    <>
      <Tabs
        defaultActiveKey={tabIndex}
        items={tabItems}
        onChange={onChange}
      />
      <Modal
        title={modatTitel}
        loading={isPending1.toString()}
        width={400}
        centered
        open={modalOpen}
        //cancelText="Schließen"
        onCancel={() => {
          setModalOpen(false);
        }}
        //onOk={() => form.submit()}
        //okText="Speichern"
        okButtonProps={{ style: { display: "none" } }} // Hier wird der OK-Button ausgeblendet
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <EvidenzEvAdrDatenEdit
          tabIndex={tabIndex}
          editDaten={evadrData}
          handleFinish={handleFinish}
          handleDelete={() => setModalOpen2(true)}
        />
      </Modal>
      <DeleteConfirmationModal
        title="Evidenz Datensatz löschen"
        text="Verwenden Sie dazu die Evidenz Klassik. Es sind zu viele Abhängigkeiten damit verbunden!"
        visible={modalOpen2}
        onConfirmDelete={handleDelete}
        onCancel={() => setModalOpen2(false)}
      />
    </>
  );
};
